"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureByKeyReducer = exports.simpleFeatureReducer = exports.getDefaultCGFeature = exports.isFeatureDataTooFresh = exports.defaultCGTime = exports.defaultCGError = exports.defaultCGStatus = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
exports.defaultCGStatus = { inProgress: false, loaded: false };
exports.defaultCGError = { isError: false, error: undefined };
exports.defaultCGTime = { updatedAt: 0 };
const isFeatureDataTooFresh = (time = { updatedAt: 0 }, timeoutSec = 15) => {
    if (time) {
        const differenceBetweenMillis = DateTimeUtils_1.DateTimeUtils.getDifferenceBetweenMillis(time.updatedAt, DateTimeUtils_1.DateTimeUtils.now());
        return differenceBetweenMillis.seconds <= timeoutSec;
    }
    return false;
};
exports.isFeatureDataTooFresh = isFeatureDataTooFresh;
function getDefaultCGFeature() {
    return lodash_1.default.cloneDeep({
        status: exports.defaultCGStatus,
        error: exports.defaultCGError,
        data: undefined,
        time: exports.defaultCGTime,
    });
}
exports.getDefaultCGFeature = getDefaultCGFeature;
function simpleFeatureReducer(state, newState) {
    if (newState == undefined) {
        if (process.env.NODE_ENV === "development") {
            console.error("simpleFeatureReducer: newState is undefined", newState, " => will use empty result");
        }
        return {};
    }
    const result = { ...state };
    lodash_1.default.each(newState, (value, key) => {
        if (value === undefined) {
            result[key] = undefined;
        }
        else {
            result[key] = {
                ...result[key],
                ...value
            };
        }
    });
    return result;
}
exports.simpleFeatureReducer = simpleFeatureReducer;
function featureByKeyReducer(state, newState) {
    if (lodash_1.default.isEmpty(newState)) {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("featureReducer: newState is empty", newState, " => will use empty result");
        }
        return {};
    }
    // console.log("featureReducer: state", _.cloneDeep(state));
    // console.log("featureReducer: newState", _.cloneDeep(newState));
    const result = { ...state };
    lodash_1.default.each(newState, (newPartialFeature, key_identifier) => {
        if (lodash_1.default.isEmpty(result[key_identifier])) {
            result[key_identifier] = getDefaultCGFeature();
        }
        const featureResult = {
            ...result[key_identifier]
        };
        lodash_1.default.each(newPartialFeature, (newPartialFeatureValue, newPartialFeatureKey) => {
            if (newPartialFeatureValue == undefined) {
                featureResult[newPartialFeatureKey] = undefined;
            }
            else {
                featureResult[newPartialFeatureKey] = {
                    ...featureResult[newPartialFeatureKey],
                    ...newPartialFeatureValue,
                };
            }
        });
        result[key_identifier] = {
            ...result[key_identifier],
            ...featureResult
        };
    });
    return result;
}
exports.featureByKeyReducer = featureByKeyReducer;
